<template>
  <div :class="classObj" class="app-wrapper" :style="{'--current-color': theme}">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"/>
    <sidebar class="sidebar-container"/>
    <div :class="{hasTagsView:needTagsView}" class="main-container">
      <div :class="{'fixed-header':fixedHeader}">
        <navbar />
        <tags-view v-if="needTagsView" />
      </div>
      <app-main />
      <right-panel>
        <settings />
      </right-panel>
    </div>
  </div>
</template>

<script>
  import RightPanel from '@/components/RightPanel'
  import { AppMain, Navbar, Settings, Sidebar, TagsView } from './components'
  import ResizeMixin from './mixin/ResizeHandler'
  import { mapState } from 'vuex'
  import variables from '@/assets/styles/variables.scss'
  import Cookies from "js-cookie";

  export default {
    name: 'Layout',
    components: {
      AppMain,
      Navbar,
      RightPanel,
      Settings,
      Sidebar,
      TagsView
    },

    data() {
      return {
        url: "ws://47.99.240.154:8011/websocket/"+Cookies.get('userId'),
        // url: "ws://192.168.2.208:8011/websocket/"+Cookies.get('userId'),
        message: "",
        text_content: "",
        ws: null,
        userType:Cookies.get('userType')
      };
    },
    mixins: [ResizeMixin],
    computed: {
      ...mapState({
        theme: state => state.settings.theme,
        sideTheme: state => state.settings.sideTheme,
        sidebar: state => state.app.sidebar,
        device: state => state.app.device,
        needTagsView: state => state.settings.tagsView,
        fixedHeader: state => state.settings.fixedHeader
      }),
      classObj() {
        return {
          hideSidebar: !this.sidebar.opened,
          openSidebar: this.sidebar.opened,
          withoutAnimation: this.sidebar.withoutAnimation,
          mobile: this.device === 'mobile'
        }
      },
      variables() {
        return variables;
      }
    },
    methods: {
      handleClickOutside() {
        this.$store.dispatch('app/closeSideBar', { withoutAnimation: false })
      }
      ,join() {
        const wsuri = this.url;
        this.ws = new WebSocket(wsuri);
        const self = this;
        this.ws.onopen = function (event) {
          console.log("已经打开连接!");
        };
        this.ws.onmessage = function (event) {
          // console.log(event);
          self.$notify({
            title: '提示',
            message: event.data,
            position: 'bottom-right',
            duration: 10000
          });
        };
        this.ws.onclose = function (event) {
          console.log(self.text_content + "已经关闭连接!" + "\n");
        };
      },
      exit() {
        if (this.ws) {
          this.ws.close();
          this.ws = null;
        }
      },
      send() {
        if (this.ws) {
          this.ws.send(this.message);
        } else {
          alert("未连接到服务器");
        }
      },
    },
    mounted() {
      if('1'==this.userType || '4'==this.userType){
        this.join();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/mixin.scss";
  @import "~@/assets/styles/variables.scss";

  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;

    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }

  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }

  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$base-sidebar-width});
    transition: width 0.28s;
  }

  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }

  .mobile .fixed-header {
    width: 100%;
  }
</style>
